import Swal, {SweetAlertOptions} from 'sweetalert2';
import {Route} from '@angular/router';

const _swalConfig = Swal.mixin({
    customClass: {
        container: '_ui-swal-container',
        confirmButton: '_ui-swal-confirm',
        cancelButton: '_ui-swal-cancel',
        denyButton: '_ui-swal-deny',
        actions: '_ui-swal-actions',
        popup: '_ui-swal-popup',
        title: '_ui-swal-title',
        loader: '_ui-swal-loader',
        icon: '_ui-swal-icon',
        image: '_ui-swal-image',
        htmlContainer: '_ui-swal-html-container',
        timerProgressBar: '_ui-swal-timer-progress-bar',
        closeButton: '_ui-swal-close-button',
    },
    reverseButtons: true,
} as SweetAlertOptions);

const _swalDefaultOptions = {
    boolean(options: SweetAlertOptions) {
        options = {
            showDenyButton: true,
            denyButtonText: 'Recusar',

            showCancelButton: false,
            cancelButtonText: 'Cancelar',

            showConfirmButton: true,
            confirmButtonText: 'Aceitar',

            showCloseButton: true,
            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
    confirm(options: SweetAlertOptions) {
        options = {
            showDenyButton: false,
            denyButtonText: 'Contestar',

            showCancelButton: true,
            cancelButtonText: 'Cancelar',

            showConfirmButton: true,
            confirmButtonText: 'Confirmar',

            showCloseButton: false,
            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
    remove(options: SweetAlertOptions) {
        options = {
            showDenyButton: true,
            denyButtonText: 'Remover',

            showCancelButton: true,
            cancelButtonText: 'Cancelar',

            showConfirmButton: false,
            confirmButtonText: 'Editar',

            showCloseButton: false,
            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
    add(options: SweetAlertOptions) {
        options = {
            showDenyButton: false,
            denyButtonText: 'Editar',

            showCancelButton: true,
            cancelButtonText: 'Cancelar',

            showConfirmButton: true,
            confirmButtonText: 'Adicionar',

            showCloseButton: false,
            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
    alert(options: SweetAlertOptions) {
        options = {
            showDenyButton: false,
            denyButtonText: 'Retornar',

            showCancelButton: true,
            cancelButtonText: 'Fechar',

            showConfirmButton: false,
            confirmButtonText: 'OK',

            showCloseButton: false,
            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
    blank(options: SweetAlertOptions) {
        options = {
            showDenyButton: false,
            denyButtonText: 'Negar',

            showCancelButton: false,
            cancelButtonText: 'Fechar',

            showConfirmButton: false,
            confirmButtonText: 'Confirmar',

            showCloseButton: true,

            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options);
    },
}

const UiSwal = Object.assign(_swalConfig, {
    ..._swalDefaultOptions,
    redirect(options: SweetAlertOptions, url: Route, milisseconds: number = 5000) {
        options = {
            showDenyButton: false,
            denyButtonText: 'Retornar',

            showCancelButton: true,
            cancelButtonText: 'Permanecer',

            showConfirmButton: true,
            confirmButtonText: 'Redirecionar',

            showCloseButton: false,

            text: options.text + ' Você será redirecionado em 5 segundos.',

            timerProgressBar: true,
            timer: milisseconds,

            ...options,
        } as SweetAlertOptions;

        return _swalConfig.fire(options).then((r) => {
            if (r.isConfirmed) {
                this.router.navigate(url).then();
            }
        });
    },
});

export default UiSwal;
